export class ContactPhoneSelection {
    contactId: number = 0;
    truckerId: number = 0;
    phone1Selected: boolean = false;
    phone2Selected: boolean = false;
}